









































import { Component, Prop, Vue } from "vue-property-decorator";
import SkeletonLoader from "@/modules/externals/components/SkeletonLoader.vue";
@Component({
  components: {
    "skeleton-loader": SkeletonLoader,
  },
})
export default class NationalId extends Vue {
  @Prop()
  front!: string;
  @Prop()
  back!: string;
  frontImageLoading = true;

  isFrontSelected = true;
  toggleFrontNational() {
    this.isFrontSelected = true;
  }
  toggleBackNational() {
    this.isFrontSelected = false;
  }
  onFrontImageLoad() {
    this.frontImageLoading = false;
  }
}
